import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { IMG } from "@/lib/api";

const MediaCtx = createContext({ media: {}, refresh: () => {} });

export function MediaProvider({ children }) {
  const [media, setMedia] = useState({});

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/media");
      setMedia(r.data || {});
    } catch {
      /* silent — fallbacks will render */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <MediaCtx.Provider value={{ media, refresh }}>{children}</MediaCtx.Provider>;
}

export function useMediaCtx() {
  return useContext(MediaCtx);
}

// Convenience hook: returns user-uploaded image for `key` or the supplied fallback URL.
export function useImage(key, fallback) {
  const { media } = useContext(MediaCtx);
  return media?.[key] || fallback;
}

// Friendly metadata for the admin Brand Media UI.
export const MEDIA_SLOTS = [
  { key: "hero", name: "Home Hero Background", description: "Cinematic full-bleed background behind the headline. Wide landscape, ~1920×1080, dark-toned.", default_url: IMG.hero },
  { key: "driver_section", name: "Driver Partner Portrait", description: "Used in the homepage 'Built around drivers' section. Vertical or square, person-focused.", default_url: IMG.driver },
  { key: "founder", name: "Founder Portrait (V. Karthik Neal)", description: "Used on Investors page founder card. Clean portrait, neutral background.", default_url: null },
  { key: "tech_bg", name: "Strategic Pillars / Investor Background", description: "Abstract dark-toned texture or wide cityscape. Used on Home strategic pillars + Investor hero.", default_url: IMG.network },
  { key: "hyderabad", name: "Hyderabad / HQ Image", description: "Used on Contact page beside the map. Hyderabad cityscape or your HQ exterior.", default_url: IMG.hyderabad },
];
